import React from 'react';
import { Textarea as BulmaTextarea } from 'react-bulma-components/lib/components/form';

import './style.scss';

export const Textarea = ({ placeholder = 'Text', ...props }) => (
  <BulmaTextarea placeholder={placeholder} {...props} />
);

export default Textarea;
